export default __webpack_public_path__ + "static/media/logo-facebook.79064255.png";